import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Nav from '../shared/Nav';
import './Academy.css';

// Módulos de la academia — en producción vendrían de la API
const MODULES = {
  common: [
    {
      id: 'mod1',
      title: 'Bienvenida e identidad Impekble',
      type: 'common',
      duration: '~12 min',
      lessons: [
        { id: '1.1', title: '¿Qué es Impekble y por qué importa la calidad?', duration: '4 min' },
        { id: '1.2', title: 'Cómo luce un trabajo bien hecho', duration: '5 min' },
        { id: '1.3', title: 'Presentación personal y puntualidad', duration: '3 min' },
      ],
    },
    {
      id: 'mod2',
      title: 'Herramientas, productos y seguridad',
      type: 'common',
      duration: '~18 min',
      lessons: [
        { id: '2.1', title: 'Tipos de paños y su uso correcto', duration: '5 min' },
        { id: '2.2', title: 'Productos de limpieza: cuándo y cómo', duration: '6 min' },
        { id: '2.3', title: 'Mezclas prohibidas y riesgos', duration: '4 min' },
        { id: '2.4', title: 'Orden del kit de trabajo', duration: '3 min' },
      ],
    },
  ],
  limpieza: [
    {
      id: 'mod3-limpieza',
      title: 'Limpieza de habitaciones y áreas comunes',
      type: 'role',
      duration: '~20 min',
      lessons: [
        { id: '3.1', title: 'Orden correcto en una habitación', duration: '5 min' },
        { id: '3.2', title: 'Cama perfecta estándar Impekble', duration: '6 min' },
        { id: '3.3', title: 'Puntos que los inspectores siempre revisan', duration: '5 min' },
        { id: '3.4', title: 'Qué hacer si hay pertenencias del huésped', duration: '4 min' },
      ],
    },
    {
      id: 'mod4-limpieza',
      title: 'Baños y cocinas: zonas críticas',
      type: 'role',
      duration: '~22 min',
      lessons: [
        { id: '4.1', title: 'Baño: secuencia correcta', duration: '6 min' },
        { id: '4.2', title: 'Cocina: desengrase real', duration: '6 min' },
        { id: '4.3', title: 'Acero inoxidable y superficies delicadas', duration: '5 min' },
        { id: '4.4', title: 'Foto de cierre: qué debe incluir', duration: '5 min' },
      ],
    },
  ],
  lavado: [
    {
      id: 'mod3-lavado',
      title: 'Proceso completo de lavado',
      type: 'role',
      duration: '~20 min',
      lessons: [
        { id: '3.1', title: 'Clasificación y pre-tratamiento', duration: '5 min' },
        { id: '3.2', title: 'Temperaturas y ciclos por tipo de tela', duration: '6 min' },
        { id: '3.3', title: 'Secado, doblado y estándares', duration: '5 min' },
        { id: '3.4', title: 'Registro de prendas en el sistema', duration: '4 min' },
      ],
    },
    {
      id: 'mod4-lavado',
      title: 'Armado de paquetes y control de inventario',
      type: 'role',
      duration: '~18 min',
      lessons: [
        { id: '4.1', title: 'Checklist de paquete limpio', duration: '6 min' },
        { id: '4.2', title: 'Código QR y trazabilidad', duration: '6 min' },
        { id: '4.3', title: 'Manejo de faltantes o daños', duration: '6 min' },
      ],
    },
  ],
  inspector: [
    {
      id: 'mod3-inspector',
      title: 'Metodología de inspección por ambiente',
      type: 'role',
      duration: '~20 min',
      lessons: [
        { id: '3.1', title: 'Checklist por ambiente', duration: '5 min' },
        { id: '3.2', title: 'Fotografía como evidencia', duration: '5 min' },
        { id: '3.3', title: 'Errores comunes vs. errores críticos', duration: '5 min' },
        { id: '3.4', title: 'Validación cruzada con operador', duration: '5 min' },
      ],
    },
    {
      id: 'mod4-inspector',
      title: 'Reportes, retrabajos y escalamiento',
      type: 'role',
      duration: '~18 min',
      lessons: [
        { id: '4.1', title: 'Generar retrabajo automático', duration: '5 min' },
        { id: '4.2', title: 'Escalamiento a jefe de operaciones', duration: '5 min' },
        { id: '4.3', title: 'Score del operador: cómo funciona', duration: '4 min' },
        { id: '4.4', title: 'Reportes de inspección', duration: '4 min' },
      ],
    },
  ],
  commonFinal: [
    {
      id: 'mod5',
      title: 'Uso de la app Impekble (Teams App)',
      type: 'common',
      duration: '~15 min',
      lessons: [
        { id: '5.1', title: 'Iniciar y cerrar un servicio', duration: '4 min' },
        { id: '5.2', title: 'Completar el checklist', duration: '4 min' },
        { id: '5.3', title: 'Reportar un incidente o daño', duration: '4 min' },
        { id: '5.4', title: 'Modo offline y sincronización', duration: '3 min' },
      ],
    },
  ],
};

export default function Academy() {
  const { accessCode } = useParams();
  const navigate = useNavigate();

  // TODO: Validar accessCode contra la API
  // En producción: GET /api/recruitment/academy/{accessCode}
  const role = 'limpieza'; // Vendría de la API
  const expiresAt = new Date(Date.now() + 47 * 3600 * 1000); // Demo: 47hrs

  const [completedModules, setCompletedModules] = useState(new Set());
  const [expandedModule, setExpandedModule] = useState(null);
  const [countdown, setCountdown] = useState('');

  // Armar lista de módulos para este rol
  const allModules = [
    ...MODULES.common,
    ...(MODULES[role] || []),
    ...MODULES.commonFinal,
  ];

  // Countdown
  useEffect(() => {
    const interval = setInterval(() => {
      const diff = Math.max(0, expiresAt - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setCountdown(`${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleModule = (id) => {
    if (isLocked(id)) return;
    setExpandedModule(expandedModule === id ? null : id);
  };

  const markDone = (id) => {
    setCompletedModules((prev) => new Set([...prev, id]));
    setExpandedModule(null);
    // TODO: POST /api/recruitment/academy/{accessCode}/progress
  };

  const isLocked = (moduleId) => {
    const idx = allModules.findIndex((m) => m.id === moduleId);
    if (idx === 0) return false;
    const prevModule = allModules[idx - 1];
    return !completedModules.has(prevModule.id);
  };

  const allDone = allModules.every((m) => completedModules.has(m.id));

  const getModuleStatus = (id) => {
    if (completedModules.has(id)) return 'done';
    if (isLocked(id)) return 'locked';
    return 'available';
  };

  return (
    <div className="academy">
      <Nav>
        <div className="academy__access-badge ik-badge ik-badge--teal">
          <span className="academy__pulse-dot" />
          Acceso disponible: <strong>{countdown}</strong>
        </div>
      </Nav>

      <div className="academy__body">
        <div className="academy__header">
          <h2 className="ik-section-title">Academia Impekble</h2>
          <p className="ik-section-sub">
            Completa todos los módulos antes de que venza tu acceso. Al finalizar se habilitará el examen.
          </p>
        </div>

        <div className="ik-alert ik-alert--warning">
          Tu acceso a los videos vence en <strong>{countdown.split(':')[0]} horas</strong>.
          Una vez vencido, se habilitará el examen automáticamente.
        </div>

        <div className="academy__modules">
          {allModules.map((mod, idx) => {
            const status = getModuleStatus(mod.id);
            return (
              <div
                key={mod.id}
                className={`academy__module academy__module--${status}`}
              >
                <div className="academy__module-row" onClick={() => toggleModule(mod.id)}>
                  <div className={`academy__module-num academy__module-num--${status}`}>
                    {status === 'done' ? '✓' : idx + 1}
                  </div>
                  <div className="academy__module-info">
                    <div className="academy__module-name">{mod.title}</div>
                    <div className="academy__module-sub">
                      {mod.type === 'common' ? 'Módulo común' : `Módulo ${role}`} · {mod.duration}
                    </div>
                  </div>
                  <span className={`ik-badge ik-badge--${status === 'done' ? 'success' : status === 'locked' ? 'gray' : 'teal'}`}>
                    {status === 'done' ? 'Completado' : status === 'locked' ? 'Bloqueado' : 'Ver ahora'}
                  </span>
                </div>

                {expandedModule === mod.id && (
                  <div className="academy__module-expand ik-fade-in">
                    <div className="academy__lessons">
                      {mod.lessons.map((lesson) => (
                        <div className="academy__lesson" key={lesson.id}>
                          <span className="academy__lesson-icon">▶️</span>
                          <span className="academy__lesson-title">{lesson.title}</span>
                          <span className="academy__lesson-time">{lesson.duration}</span>
                        </div>
                      ))}
                    </div>
                    <button
                      className="ik-btn ik-btn--primary ik-btn--block"
                      style={{ marginTop: 16 }}
                      onClick={() => markDone(mod.id)}
                    >
                      Marcar como visto ✓
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <button
          className="ik-btn ik-btn--primary ik-btn--block ik-btn--lg"
          style={{ marginTop: 28 }}
          disabled={!allDone}
          onClick={() => navigate(`/examen/${accessCode}`)}
        >
          {allDone ? '🎓 Ir al examen final →' : '🎓 Examen disponible al completar todos los módulos'}
        </button>
      </div>
    </div>
  );
}
